import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'providers/nz/te-rito/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('teRito/', '')
      .toLowerCase();
  }
}
